import { render, staticRenderFns } from "./SecondSectionView.vue?vue&type=template&id=45a3ea03&"
import script from "./SecondSectionView.vue?vue&type=script&lang=js&"
export * from "./SecondSectionView.vue?vue&type=script&lang=js&"
import style0 from "./SecondSectionView.vue?vue&type=style&index=0&id=45a3ea03&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports